import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
export default _ConfigProvider;
var globalMessagePosition = 'right';
export var setGlobalConfig = function setGlobalConfig(_ref) {
  var messagePosition = _ref.messagePosition;

  if (messagePosition !== undefined) {
    globalMessagePosition = messagePosition;
  }
};
export var getGlobalConfig = function getGlobalConfig() {
  return {
    messagePosition: globalMessagePosition
  };
};
//# sourceMappingURL=index.js.map